/** Minimal vCard (.vcf) parser — FN/N, TEL, ADR (mirrors mobile). */
export function parseVcard(text) {
  const lines = String(text || "").split(/\r?\n/);
  const out = {};
  for (const raw of lines) {
    const line = raw.trim();
    const upper = line.toUpperCase();
    if (!out.name && upper.startsWith("FN")) {
      out.name = line.split(":").slice(1).join(":").trim();
    } else if (!out.name && upper.startsWith("N:")) {
      const parts = line.split(":").slice(1).join(":").split(";").filter(Boolean);
      out.name = parts.reverse().join(" ").trim();
    } else if (!out.phone && upper.startsWith("TEL")) {
      out.phone = line.split(":").slice(1).join(":").trim().replace(/[^\d+]/g, "");
    } else if (!out.address && upper.startsWith("ADR")) {
      const adr = line.split(":").slice(1).join(":");
      out.address = adr.split(";").filter(Boolean).join(", ").trim();
    }
  }
  return out;
}
